import { Injectable } from '@angular/core';

@Injectable()
export class ObjectDiffFinderService {
    openChar = '{';
    closeChar = '}';

    constructor() { }

    equalObj(obj) {
        return {
            changed: 'equal',
            value: obj
        }
    }
    isValidAttr(a, b) {
        let typeA = typeof a;
        let typeB = typeof b;
        return (a && b && (typeA === 'object' || typeA === 'function') && (typeB === 'object' || typeB === 'function'));
    }

    stringifyObjectKey(key) {
        return /^[a-z0-9_$]*$/i.test(key) ?
            key :
            JSON.stringify(key);
    }

    escapeHTML(string) {
        return string.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    formatChange(key, diffItem, shallow?, diffOnly?) {
        let changed = diffItem.changed;
        let property;
        switch (changed) {
            case 'equal':
                property = (this.stringifyObjectKey(this.escapeHTML(key)) + '<span>: </span>' + this.inspect(diffItem.value));
                break;

            case 'removed':
                property = ('<del class="diff">' + this.stringifyObjectKey(this.escapeHTML(key)) + '<span>: </span>' +
                    this.inspect(diffItem.value) + '</del>');
                break;

            case 'added':
                property = ('<ins class="diff">' + this.stringifyObjectKey(this.escapeHTML(key)) + '<span>: </span>' +
                    this.inspect(diffItem.value) + '</ins>');
                break;

            case 'primitive change':
                let prefix = this.stringifyObjectKey(this.escapeHTML(key)) + '<span>: </span>';
                property = (
                    '<del class="diff diff-key">' + prefix + this.inspect(diffItem.removed) + '</del><span>,</span>\n' +
                    '<ins class="diff diff-key">' + prefix + this.inspect(diffItem.added) + '</ins>');
                break;

            case 'object change':
                property = shallow ? '' : (this.stringifyObjectKey(key) + '<span>: </span>' +
                    (diffOnly ? this.formatChangesToXMLString(diffItem) : this.formatToJsonXMLString(diffItem)));
                break;
        }

        return property;
    }

    inspect(obj, shallow?) {

        return this.accInspect('', obj, shallow);
    }
    accInspect(accumulator, obj, shallow?) {
        switch (typeof obj) {
            case 'object':
                if (!obj) {
                    accumulator += 'null';
                    break;
                }
                if (shallow) {
                    accumulator += '[object]';
                    break;
                }
                let keys = Object.keys(obj);
                let length = keys.length;
                if (length === 0) {
                    if (Array.isArray(obj)) {
                        accumulator += '<span>' + '[' + ']' + '</span>';
                    } else {
                        accumulator += '<span>' + this.openChar + this.closeChar + '</span>';
                    }

                } else {
                    if (Array.isArray(obj)) {
                        accumulator += '<span>' + '[' + '</span>\n<div class="diff-level">';
                        for (let i = 0; i < length; i++) {
                            let key = keys[i];
                            accumulator = this.accInspect(accumulator, obj[key]);
                            if (i < length - 1) {
                                accumulator += '<span>,</span>\n';
                            }
                        }
                        accumulator += '\n</div><span>' + ']' + '</span>'
                    } else {
                        accumulator += '<span>' + this.openChar + '</span>\n<div class="diff-level">';
                        for (let i = 0; i < length; i++) {
                            let key = keys[i];

                            accumulator = this.accInspect(accumulator + this.stringifyObjectKey(this.escapeHTML(key)) +
                                '<span>: </span>', obj[key]);
                            if (i < length - 1) {
                                accumulator += '<span>,</span>\n';
                            }
                        }
                        accumulator += '\n</div><span>' + this.closeChar + '</span>'
                    }
                }
                break;

            case 'string':
                accumulator += JSON.stringify(this.escapeHTML(obj));
                break;

            case 'undefined':
                accumulator += 'undefined';
                break;

            default:
                accumulator += this.escapeHTML(String(obj));
                break;
        }
        return accumulator;
    }


    /**
     * Convert to a readable xml/html Json structure
     */
    formatToJsonXMLString(changes, shallow?) {
        let properties = [];

        let diff = changes.value;
        if (changes.changed === 'equal') {
            return this.inspect(diff, shallow);
        }

        for (let key in diff) {
            properties.push(this.formatChange(key, diff[key], shallow));
        }

        return ('<span>' + this.openChar + '</span>\n<div class="diff-level">' + properties.join('<span>,</span>\n') +
            '\n</div><span>' + this.closeChar + '</span>');

    }

    /**
     * Convert to a readable xml/html Json structure
     */
    formatChangesToXMLString(changes, shallow?) {
        let properties = [];

        if (changes.changed === 'equal') {
            return '';
        }

        let diff = changes.value;

        for (let key in diff) {
            let changed = diff[key].changed;
            if (changed !== 'equal'){
                properties.push(this.formatChange(key, diff[key], shallow, true));
            }
        }

        return ('<span>' + this.openChar + '</span>\n<div class="diff-level">' + properties.join('<span>,</span>\n') +
            '\n</div><span>' + this.closeChar + '</span>');

    }


    diffObject(a, b, shallow, isOwn) {

        if (a === b) {
            return this.equalObj(a);
        }

        let diffValue = {};
        let equal = true;

        for (let key in a) {
            if ((!isOwn && key in b) || (isOwn && typeof b !== 'undefined' && b.hasOwnProperty(key))) {
                if (a[key] === b[key]) {
                    diffValue[key] = this.equalObj(a[key]);
                } else {
                    if (!shallow && this.isValidAttr(a[key], b[key])) {
                        let valueDiff = this.diffObject(a[key], b[key], shallow, isOwn);
                        if (valueDiff.changed === 'equal') {
                            diffValue[key] = this.equalObj(a[key]);
                        } else {
                            equal = false;
                            diffValue[key] = valueDiff;
                        }
                    } else {
                        equal = false;
                        diffValue[key] = {
                            changed: 'primitive change',
                            removed: a[key],
                            added: b[key]
                        }
                    }
                }
            } else {
                equal = false;
                diffValue[key] = {
                    changed: 'removed',
                    value: a[key]
                }
            }
        }

        for (let key in b) {
            if ((!isOwn && !(key in a)) || (isOwn && typeof a !== 'undefined' && !a.hasOwnProperty(key))) {
                equal = false;
                diffValue[key] = {
                    changed: 'added',
                    value: b[key]
                }
            }
        }

        if (equal) {
            return this.equalObj(a);
        } else {
            return {
                changed: 'object change',
                value: diffValue
            }
        }
    }

}
